import React, { Component } from 'react';
import cx from 'classnames';
import { Modal } from 'react-bootstrap';
import { Player } from '@lottiefiles/react-lottie-player';
import styles from './_mobileSetupLoaderModal.module.scss';
import './_mobileSetupLoaderModalModal.scss';

export default class MobileSetupLoaderModal extends Component {
  render() {
    const { isModalVisible } = this.props;
    return (
      <div className={cx(styles['mobile-cancel-purchase'])}>
        <Modal show={isModalVisible} size="lg" centered>
          <div className="mobile-cancel-purchase">
            <div>
              <div className="cancel-purchase-title">PLEASE NOTE</div>

              <div className="cancel-purchase-rewards">
                <div className="cancel-purchase-not-leaving">
                  This may take a few minutes, please do not refresh or close this tab
                </div>
                <Player
                  autoplay
                  loop
                  keepLastFrame
                  src="https://assets6.lottiefiles.com/packages/lf20_5xjxnhli.json"
                  className="sand-clock-mobile"
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
